import { addMessages } from '@hana/i18n';

// Khoá chuỗi của danh sách chuyến tàu trong P2P (SchedList.tsx). Tên tàu, chuyến, mã cảng, mã hãng không dịch.
addMessages('vi', {
  'sl.wd0': 'Chủ nhật',
  'sl.wd1': 'Thứ hai',
  'sl.wd2': 'Thứ ba',
  'sl.wd3': 'Thứ tư',
  'sl.wd4': 'Thứ năm',
  'sl.wd5': 'Thứ sáu',
  'sl.wd6': 'Thứ bảy',
  'sl.ws0': 'CN',
  'sl.ws1': 'T2',
  'sl.ws2': 'T3',
  'sl.ws3': 'T4',
  'sl.ws4': 'T5',
  'sl.ws5': 'T6',
  'sl.ws6': 'T7',
  'sl.cutDone': 'đã cắt',
  'sl.leftDH': 'còn {d} ngày {h} giờ',
  'sl.leftHM': 'còn {h} giờ {m}\'',
  'sl.ttAll': 'Mọi transit',
  'sl.tt7': '≤ 7 ngày',
  'sl.tt14': '≤ 14 ngày',
  'sl.title': 'Lịch tàu',
  'sl.selAll': 'Chọn tất cả chuyến đang hiện',
  'sl.all': 'Tất cả',
  'sl.byCarrier': 'Lọc theo hãng',
  'sl.allCarriers': 'Mọi hãng',
  'sl.filter': 'Lọc lịch tàu',
  'sl.filterBtn': 'Lọc',
  'sl.route': 'Đường đi',
  'sl.direct+ts': 'Thẳng + chuyển tải',
  'sl.directOnly': 'Chỉ đi thẳng',
  'sl.allSvc': 'Mọi service',
  'sl.noMatch': 'Không có chuyến khớp bộ lọc',
  'sl.noMatchD': 'Mở rộng khoảng ETD hoặc bỏ lọc.',
  'sl.sailings': 'Chuyến tàu',
  'sl.sailing': 'Chuyến {name}',
  'sl.pick': 'Chọn {name} cho Multi Book',
  'sl.pickTip': 'Chọn cho Multi Book / gửi khách',
  'sl.days': '{n} ngày',
  'sl.via': 'qua {v}',
  'sl.directLow': 'đi thẳng',
  'sl.directUp': 'Đi thẳng',
  'sl.fcTip': 'Forecast ETD lệch so với lịch',
  'sl.vsl': 'Tàu / Chuyến · Tuyến',
  'sl.unmapped': 'Service chưa map',
  'sl.spSoon': 'Sắp đầy',
  'sl.spFull': 'Hết chỗ',
  'sl.held': ' · HANA giữ {n} TEU',
  'sl.cutCy': 'Cắt máng cảng',
  'sl.operators': 'Hãng khai thác: {v}',
  'sl.bookTip': 'Book chuyến này',
  'sl.openVessel': 'Mở hồ sơ tàu',
  'sl.detailAria': 'Mở chi tiết {name}: cut-off, lịch trình, forecast',
  'sl.detailTip': 'Chi tiết · cut-off, lịch trình, forecast',
});
addMessages('en', {
  'sl.wd0': 'Sunday',
  'sl.wd1': 'Monday',
  'sl.wd2': 'Tuesday',
  'sl.wd3': 'Wednesday',
  'sl.wd4': 'Thursday',
  'sl.wd5': 'Friday',
  'sl.wd6': 'Saturday',
  'sl.ws0': 'Sun',
  'sl.ws1': 'Mon',
  'sl.ws2': 'Tue',
  'sl.ws3': 'Wed',
  'sl.ws4': 'Thu',
  'sl.ws5': 'Fri',
  'sl.ws6': 'Sat',
  'sl.cutDone': 'cut off',
  'sl.leftDH': '{d}d {h}h left',
  'sl.leftHM': '{h}h {m}m left',
  'sl.ttAll': 'Any transit',
  'sl.tt7': '≤ 7 days',
  'sl.tt14': '≤ 14 days',
  'sl.title': 'Sailing schedule',
  'sl.selAll': 'Select all shown sailings',
  'sl.all': 'All',
  'sl.byCarrier': 'Filter by carrier',
  'sl.allCarriers': 'All carriers',
  'sl.filter': 'Filter sailings',
  'sl.filterBtn': 'Filter',
  'sl.route': 'Routing',
  'sl.direct+ts': 'Direct + transshipment',
  'sl.directOnly': 'Direct only',
  'sl.allSvc': 'All services',
  'sl.noMatch': 'No sailings match the filters',
  'sl.noMatchD': 'Widen the ETD range or clear filters.',
  'sl.sailings': 'Sailings',
  'sl.sailing': 'Sailing {name}',
  'sl.pick': 'Select {name} for Multi Book',
  'sl.pickTip': 'Select for Multi Book / send to customer',
  'sl.days': '{n} days',
  'sl.via': 'via {v}',
  'sl.directLow': 'direct',
  'sl.directUp': 'Direct',
  'sl.fcTip': 'Forecast ETD differs from schedule',
  'sl.vsl': 'Vessel / Voyage · Lane',
  'sl.unmapped': 'Service not mapped',
  'sl.spSoon': 'Almost full',
  'sl.spFull': 'Full',
  'sl.held': ' · HANA holds {n} TEU',
  'sl.cutCy': 'CY cut-off',
  'sl.operators': 'Operating carriers: {v}',
  'sl.bookTip': 'Book this sailing',
  'sl.openVessel': 'Open vessel profile',
  'sl.detailAria': 'Open details of {name}: cut-offs, itinerary, forecast',
  'sl.detailTip': 'Details · cut-offs, itinerary, forecast',
});
